import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid/lib/index";
import { withStyles } from "@material-ui/core/styles";
import { Button, Card, Typography } from "@material-ui/core";
import eightBallImg from "../static/8ball.png";

const styles = {
  root: {
    background: "#395175",
    border: 0,
    borderRadius: 3,
    boxShadow: "0 0 10px 10px rgba(255, 105, 135, .3)",
    color: "white",
    height: 48,
    padding: "0 30px"
  }
};

const RebuildStatus = props => {
  const { classes } = props;
  const [eightBallAns, setEightBallAns] = useState("");

  const answers = [
    "Not yet",
    "Doubtful",
    "Seems unlikely",
    "Outlook doesn't seem good",
    "Ask again later",
    "Cross your fingers and try again",
    "Signs point to no",
    "Don't count on it",
    "Mmmmm.... nope",
    "Stars did not align",
    "A watched pot never boils",
    "No",
    "I'm a frayed knot",
    "It's a no from me",
    "Definitely not",
    "I think not",
    "Sorry, but no",
    "Still working on it",
    "Better luck next time",
    "Please continue to hold"
  ];

  const getNewAnsIndex = () =>
    Math.floor(Math.random() * Math.floor(answers.length));

  if (!props.rebuildRunning) return <div>{props.children}</div>;

  return (
    <div>
      <Row center="xs" style={{ marginTop: "50px" }}>
        <Typography variant="h5" style={{ display: "block" }}>
          <b>
            The EIMS Data Portal is not available due to an actively running
            rebuild.
          </b>
        </Typography>
      </Row>
      <Row center="xs">
        <Typography variant="subtitle1" style={{ display: "block" }}>
          Please contact eims.support@hakai.org with any questions.
        </Typography>
      </Row>
      <Row center="xs" style={{ margin: "25px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            props.actions.checkRebuildStatus().then(r => {
              const ans = r.rebuildRunning ? answers[getNewAnsIndex()] : "";
              setEightBallAns(ans);
            });
          }}
        >
          Is the rebuild done yet?
        </Button>
      </Row>
      <Row center="xs">
        <Col xs={6} center="xs">
          <Card
            variant="outlined"
            style={{
              margin: 20,
              background: "linear-gradient(45deg, #574D97 10%, #1A5551 90%)"
            }}
          >
            <Row center="xs" style={{ margin: 20 }}>
              <img
                style={{ margin: "auto", display: "block", maxWidth: "100%" }}
                src={eightBallImg}
                alt="billiards eight ball"
              />
            </Row>
            <Row center="xs" style={{ margin: 20 }}>
              {eightBallAns && (
                <Button
                  className={classes.root}
                  disableRipple
                  disableFocusRipple
                >
                  {eightBallAns}
                </Button>
              )}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

RebuildStatus.propTypes = {
  rebuildRunning: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  classes: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    checkRebuildStatus: PropTypes.func.isRequired
  }).isRequired
};

RebuildStatus.defaultProps = {
  rebuildRunning: false
};

export default withStyles(styles)(RebuildStatus);
